//Vendor
import Page from 'Scripts/classes/Page'
// import Gallery from 'Scripts/webgl/Gallery'
import Gallery2 from 'Scripts/webgl/Gallery2'
import Particles from 'Scripts/webgl/Particles'
// import Bizaro from 'Scripts/webgl/bizaro'

//Class
export default class Home extends Page {
  constructor() {
    super(
      'home',
      {
        container: '.home',
       
      })

    //Methods
    this.init()

  }

  init() {
    // this.initGalerry()
    this.gallery2 = new Gallery2({ canvas: '.gallery', gallery : '.gallery2', medias: '.gallery2 .works__item', cases : '.work__page', wrapper : '.work__single' })
    // new Bizaro({ canvas: '.gallery', gallery: '.works', medias: '.works__item' })
    this.particles = new Particles({canvas : '.particles'})
  }


  /**
  * Animations.
  */
  show() {
    return super.show()
  }

  hide() {
    return super.hide()
  }

}


